// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1i1Le","search":"Settings_search__mefYp","filter":"Settings_filter__12URZ"};